import { Tooltip as BsTooltip } from "bootstrap";
import React, { useEffect, useRef } from "react";
import "./style.scss";

const CustomTooltip = (props) => {
  const childRef = useRef();
  const { children, placement = "auto", text, trigger = "hover", parentClass } = props;
  useEffect(() => {
    const t = new BsTooltip(childRef.current, {
      html: true,
      title: text ?? "",
      placement,
      trigger,
      customClass: "custom-tooltip",
      sanitize: true,
    });
    return () => t.hide();
  }, [props.text]);
  return (
    <span ref={childRef} className={parentClass || ""}>
      {children}
    </span>
  );
};

export default CustomTooltip;
